/* global axios */
import ApiClient from '../ApiClient';

class AiBotPlaygroundAPI extends ApiClient {
  constructor(botId) {
    super(`agent_bots/${botId}/playground`, { accountScoped: true });
  }

  sendMessage({ content }) {
    return axios.post(`${this.url}/messages`, { content });
  }

  reset() {
    return axios.delete(this.url);
  }
}

export default AiBotPlaygroundAPI;
